export const LEVEL_1 = [
  [4, 8, 10, 6],
  [7, 9, 5, 8],
  [4, 1, 3, 4],
  [9, 2, 1, 5],
];

export const LEVEL_2 = [
  [4, 1, 10, 6],
  [7, 9, 5, 8],
  [6, 0, 3, 0],
  [9, 2, 0, 5],
];

export const LEVEL_3 = [
  [4, 1, 8, 1],
  [6, 9, 5, 7],
  [8, 4, 3, 6],
  [9, 2, 0, 8],
];

export const LEVEL_4 = [
  [4, 1, 8, 1],
  [6, 9, 5, 5],
  [5, 4, 3, 6],
  [9, 2, 0, 5],
];

export const LEVEL_5 = [
  [3, 0, 10, 6],
  [7, 9, 5, 8],
  [4, 1, 3, 4],
  [9, 2, 1, 3],
];

export const LEVEL_6 = [
  [7, 0, 10, 6],
  [3, 5, 2, 8],
  [4, 1, 3, 4],
  [2, 2, 1, 5],
];

export const LEVEL_7 = [
  [2, 4, 4, 2],
  [3, 5, 6, 8],
  [4, 1, 3, 10],
  [7, 0, 1, 5],
];

export const LEVEL_8 = [
  [2, 6, 4, 2],
  [3, 5, 6, 8],
  [4, 1, 3, 10],
  [7, 0, 1, 5],
];

export const LEVEL_9 = [
  [2, 6, 4, 2],
  [3, 5, 6, 8],
  [4, 1, 3, 10],
  [5, 0, 1, 5],
];

export const LEVEL_10 = [
  [10, 0, 10, 2],
  [3, 5, 6, 8],
  [4, 1, 3, 4],
  [10, 0, 1, 10],
];
